import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
/* reducer */
import * as fromProviderDataStore from './state/provider-data-store.reducer';

/* effects */
import { ProviderDataStoreEffects } from './state/provider-data-store.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    /* ProviderDataStore State */
    StoreModule.forFeature(
      fromProviderDataStore.featureKey,
      fromProviderDataStore.reducer,
      { initialState: fromProviderDataStore.initialState },
    ),
    EffectsModule.forFeature([ProviderDataStoreEffects]),
  ],
  exports: [StoreModule, EffectsModule],
})
export class ProviderDataStoreModule {}
